import React from 'react';
import particle1 from './1.png';
import particle2 from './2.png';
import circle from './circle.svg';
import PhoneVideo from "../PhoneVideo";
import video from "./video.mp4";
import cn from 'classnames';
import style from './style.module.scss';

export default function AnimatedImage4({wrapperClass}) {
    return (
        <div className={cn(style.container, wrapperClass)}>
            <img src={particle1} alt="img" className={style.particle1}/>
            <img src={particle2} alt="img" className={style.particle2}/>
            <img src={circle} alt="img" className={style.circle}/>
            <PhoneVideo wrapperClass={style.video} video={video}/>
        </div>
    )
}